import { render, staticRenderFns } from "./brfssRouterLink.vue?vue&type=template&id=4862f048"
import script from "./brfssRouterLink.vue?vue&type=script&lang=js"
export * from "./brfssRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports